/**
 * Notes Component.
 * Its returns `div` element with Kepler `FormField` Component.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormField from 'kepler/lib/components/FormField';
import { getLastPathVariable } from '../../../lib/location-helper';
import { trackLink } from '../../../lib/analytics-helper';
import Page from '../../../lib/page';
import { parseHtmlEntities } from '../../../lib/globalHelper';

function Notes({ label }) {
  const [isLinkAdded, setIsLinkAdded] = useState(false);

  const handleAlertLinkClick = (e, link, innerText) => {
    const href = link.getAttribute('href');
    const webformPageName = getLastPathVariable(window.location);
    if (!href) {
      e.preventDefault();
      trackLink({
        id: `${webformPageName}ContentLink`,
        link: `smarthelp-${webformPageName}-webform-content-${innerText}-link-clicked|broken-link-clicked`,
      });
    } else {
      trackLink({
        id: `${webformPageName}ContentLink`,
        link: `smarthelp-${webformPageName}-webform-content-${innerText}-link-clicked|${href}`,
      });
    }
  };

  const parseContent = (content) => {
    // Adding setTimeout on top as tag element is not picked immediately safari and IE versions
    setTimeout(() => {
      if (!content || isLinkAdded) {
        return;
      }
      setIsLinkAdded(true);
      const contentLinks = content.querySelectorAll('a[href]');
      Array.from(contentLinks).forEach((link) => {
        const innerText = link.innerText || '';
        link.addEventListener('click', (e) => handleAlertLinkClick(e, link, innerText));
      });
    });
  };

  const renderNotes = () => {
    const parsedLabel = parseHtmlEntities(label);
    const innerHTML = Page.getHTMLElement({ message: parsedLabel, useHTML: true });
    return (
      <FormField>
        <div ref={(el) => parseContent(el)}>{innerHTML}</div>
      </FormField>
    );
  };

  return renderNotes();
}

// Notes Props Types.
Notes.propTypes = {
  label: PropTypes.string,
};

// Notes Props default values.
Notes.defaultProps = {
  label: '',
};

export default Notes;
